
import axios from 'axios';
import { ICidade, ISetUp, IEstado, IBairro, IAnswersRequest } from '../interfaces';

export async function getVoucher (dataVoucher: any) {
  const {data} = await axios.post(
    'https://api.n2app.info/voucher/invitation-voucher',
    dataVoucher,
    {
      headers: {
        'Authorization': `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzI0MTk1MTg0LCJqdGkiOiI4ZjM2MDVkNGVlZGQ0Mzk5YmY0NTMwOTZkNTQwM2U2NSIsInVzZXJfaWQiOjcyNTJ9.87GiL02Q-wSZD9WQ1ruMy2vSiqtkK5-aeKSLK4aEeL4`,
        'Content-Type': 'application/json',
      },
    }
  );
  return data;
}

export async function sendAnswers(request: IAnswersRequest) {
  try {
    await axios.post("https://n2-dona-de-mim-api.n2app.info/register", request);
    return true; 
  } catch (error) {
    return false;
  }
}

export async function getSetUp(): Promise<ISetUp> {
  return new Promise(async (resolve, reject) => {
    const {data} = await axios.get(process.env.PUBLIC_URL+'/setup.json');

    setTimeout(() => {
      resolve(data)
    }, 1500);
  })

  // const {data} = await axios.get(process.env.PUBLIC_URL+'/setup.json');
  // return data;
}

export async function getListLocation(uf: string, cidade: string, typedLogradouro: string): Promise<IBairro[]> {
  const {data} = await axios.get(`https://viacep.com.br/ws/${uf}/${cidade}/${typedLogradouro}/json/`);
  return data;
}

export async function getDataCEP(cep: string): Promise<IBairro> {
  const {data} = await axios.get(`https://viacep.com.br/ws/${cep}/json`);
  return data;
}

export async function getEstados(): Promise<IEstado[]> {
  const {data} = await axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome');
  return data;
}

export async function getCidades(idEstado: IEstado['id']): Promise<ICidade[]> {
  const {data} = await axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${idEstado}/municipios?orderBy=nome`);
  return data;
}
